import * as tslib_1 from "tslib";
import { Observable, of, zip as observableZip } from 'rxjs';
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as meta from '../actions/meta';
import * as facet from '../actions/facets';
import * as fromOrders from '../reducers';
var MetaEffects = /** @class */ (function () {
    function MetaEffects(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.metaInitRun$ = this.actions$.ofType(meta.INIT)
            .pipe(withLatestFrom(this.store.pipe(select(fromOrders.isInitialized)), function (action, initialized) { return initialized; }), switchMap(function (initialized) {
            if (initialized)
                return of(new meta.InitSkipped());
            return of(new facet.InitGroups(), new facet.InitFacets());
        }));
        this.metaInitComplete$ = observableZip(this.actions$.ofType(facet.INIT_GROUPS_SUCCESS, facet.INIT_GROUPS_FAILED), this.actions$.ofType(facet.INIT_FACETS_SUCCESS, facet.INIT_FACETS_FAILED)).pipe(map(function (actions) {
            var failed = actions.some(function (action) { return action.type == facet.INIT_GROUPS_FAILED
                || action.type == facet.INIT_FACETS_FAILED; });
            if (failed)
                return new meta.InitFailed();
            return new meta.InitSuccess();
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MetaEffects.prototype, "metaInitRun$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MetaEffects.prototype, "metaInitComplete$", void 0);
    return MetaEffects;
}());
export { MetaEffects };
